<template lang="pug">
div.nse-add-cart-wrap.mobile-bottom-bar
    div.entry-content
        div
            div.currency-value
                span(v-html="priceFinal")
            a(href="javascript:;" @click="SendToEmail") {{ LANG.SAVE_FOR_LATER }}

        div
            a.btn-style(href="javascript:;" @click="addToCartClick" v-if="showNextStep" :class="{'disabled': isDisabled}")
                span.addToCartText.context-button
                    | {{ LANG.FINAL_PREVIEW }}
                    img.iconArrow(:src="svgIcon")

            a.btn-style(href="javascript:;" @click="nextStep" v-else)
                span.context-button
                    | {{ LANG.NEXT_STEP_BUTTON }}
                    img.iconArrow(:src="svgIcon")

global-popup-send-email(
    :shown-email="shownEmailPopup"
    @sendEmail="sendEmailMethod"
    @closePopup="closePopupEmail"
)
</template>

<script>
import {computed, ref} from "vue";
import GlobalPopupSendEmail from "@/components/GlobalPopupSendEmail";

export default {
	name: "NSEAddCart",
	components: {
		GlobalPopupSendEmail
	},
	props: {
		priceFinal: {
			type: [Number, String]
		},
        showNextStep:{
		    type: Boolean,
            default: false
        },
		isDisabled: {
            type: Boolean,
            default: false
        },
	},

	emits: ['add_to_cart', 'submit_email', 'nextStep'],

	setup(props, {emit}) {
		const modelEmail = ref(false)

		const addToCartClick = () => {
			emit('add_to_cart')
		}

		const svgIcon = window.nse_config.assets_url + "img/arrow-add-to-cart.svg";

		const shownEmailPopup = ref(false)

		const sendEmailMethod = (email, cb) => {
			emit('submit_email', email, cb)
		}

		const closePopupEmail = () => {
			shownEmailPopup.value = false
		}
		const SendToEmail = () => {
			shownEmailPopup.value = true
		}

		const nextStep = function () {
            emit('nextStep')
        };

		return {
		    nextStep,
			addToCartClick,
			svgIcon,
			modelEmail,
			shownEmailPopup,
			sendEmailMethod,
			closePopupEmail,
			SendToEmail
		}
	}
}
</script>
